import {useHubQuery} from '../../../../common/react-query/QueryProvider'

/**
 * Fetches order change options for given order.
 * Uses React Query with order.id as key - automatically resets when order changes.
 *
 * @param orderId - The order ID to fetch options for
 * @returns React Query result with options data
 */
export const useOrderChangeOptions = (orderId: string, checkSum?: string) => {
  return useHubQuery('orderChangeOptions', [orderId, checkSum], {
    enabled: !!orderId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attempt) => Math.min(attempt > 1 ? 2000 : 1000, 30000)
  })
}
